export default "__VITE_ASSET__D1oKvb9L__"